import { render } from "./LogoutIcon.vue?vue&type=template&id=68e49bcd"
import script from "./LogoutIcon.vue?vue&type=script&lang=js"
export * from "./LogoutIcon.vue?vue&type=script&lang=js"
script.render = render

export default script